import React, { useEffect, useState } from 'react';
import logo from '../images/logo.svg';
import { NavLink } from 'react-router-dom';
import { RxHamburgerMenu } from 'react-icons/rx';
import { useTranslation } from "react-i18next";
import { trans } from "../utils";
import LangSwitcher from "./LangSwitcher";

const Header = () => {
    const [navBg, setNavBg] = useState(false);

    const changeNavBg = () => {
        window.scrollY >= 20 || document.body.clientWidth < 978 ? setNavBg(true) : setNavBg(false);
    }

    useEffect(() => {
        window.addEventListener('resize', changeNavBg);
        window.addEventListener('scroll', changeNavBg);
        return () => {
            window.removeEventListener('scroll', changeNavBg);
        }
    }, [])

    const handleCollapse = () => {
        var nav = document.getElementById("navbarSupportedContent");
        var btn = document.getElementById("navbarBtn");
        nav.classList.remove("show");
        btn.classList.add("collapsed");
    };

    return (
        <nav className={`navbar navbar-expand-lg header ${navBg && "sticky"} bg-black max-sm:py-0`}>
            <div className="container-fluid px-sm-5">

                <button className="navbar-toggler" id='navbarBtn' type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <RxHamburgerMenu color='#3385d7' />
                </button>
                <div className="collapse navbar-collapse" style={{ flexGrow: "unset" }} id="navbarSupportedContent">
                    <ul className="navbar-nav mb-2 mb-lg-0 flex gap-x-5 gap-y-2">
                        <NavLink
                            onClick={() => handleCollapse()}
                            to="/"
                            className={"text-white text-decoration-none fw-bold nav-link"}
                            style={{ fontSize: '20px' }} // Inline style for font size
                        >
                            {trans('Homepage')}
                        </NavLink>
                        <NavLink
                            onClick={() => handleCollapse()}
                            to="/transformations"
                            className={"text-white text-decoration-none fw-bold nav-link"}
                            style={{ fontSize: '20px' }} // Inline style for font size
                        >
                            {trans('Results')}
                        </NavLink>
                        <NavLink
                            onClick={() => handleCollapse()}
                            to="/contact"
                            className={"text-white text-decoration-none fw-bold nav-link"}
                            style={{ fontSize: '20px' }} // Inline style for font size
                        >
                            {trans('Contact Us')}
                        </NavLink>
                        <NavLink
                            onClick={() => handleCollapse()}
                            to="/appointment#appointFormSec"
                            className={"text-white text-decoration-none fw-bold nav-link"}
                            style={{ fontSize: '20px' }} // Inline style for font size
                        >
                            {trans('Book an appointment')}
                        </NavLink>

                        <LangSwitcher />
                    </ul>
                </div>
                <div id='imgDiv' className='navbar-brand' style={{marginRight: '0px'}}>
                    <NavLink
                        to="/"
                        className={"text-white text-decoration-none fw-bold"}
                    >
                        <img src={logo} className='inline max-sm:!w-24' />
                    </NavLink>
                </div>
            </div>
        </nav>
    )
}

export default Header;
